import React, { Fragment } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

import { Title, Avatar, IconButton, Text, ContainedButton, CalendarIcon } from '../index';

import { StyledCard, StyledCardContent, StyledAppointmentCardHeader } from './style';

export const AppointmentCard = ({
    data,
    $avatarSize,
    $desktopLayout,
    $avatarCircle,
    onClick,
    $maxWidth,
}) => {
    const today = dayjs().format('DD-MM-YYY,HH:mm');
    const session_startTime = dayjs(`${data?.date} ${data?.startTime}`)
        .subtract(10, 'minute')
        .format('DD-MM-YYY,HH:mm');
    const session_endTime = dayjs(`${data?.date} ${data?.endTime}`).format('DD-MM-YYY,HH:mm');

    return (
        <StyledCard
            variant="outlined"
            padding="0"
            margin="10px 15px 10px 0"
            $minWidth="290px"
            $maxWidth={$maxWidth}
        >
            <StyledAppointmentCardHeader>
                {data ? (
                    <Fragment>
                        <IconButton>
                            <CalendarIcon fill="white" />
                        </IconButton>
                        <Text $color="white" style={{ fontSize: '14px', margin: '2px 0 0 10px' }}>
                            {dayjs(data?.date).format('DD MMM YYYY , ')}
                            {data?.startTime.slice(0, 5)}
                        </Text>
                    </Fragment>
                ) : (
                    <Skeleton width={150} height={30} variant="text" />
                )}
            </StyledAppointmentCardHeader>
            <StyledCardContent>
                <div
                    style={{
                        padding: '10px 15px',
                        display: 'grid',

                        columnGap: '10px',
                        rowGap: '10px',

                        gridTemplateColumns: `minmax(auto,${
                            $avatarSize || '64px'
                        }) minmax(auto,85%)`,
                    }}
                >
                    <div
                        style={{
                            gridRowStart: 1,
                            gridRowEnd: $desktopLayout ? 3 : 2,
                        }}
                    >
                        {data ? (
                            <Avatar
                                alt={data?.meet?.staff?.user?.fullname}
                                src={
                                    data?.meet?.staff?.user?.avatar
                                        ? data?.meet?.staff?.user?.avatar?.url
                                        : null
                                }
                                $avatarSize={$avatarSize ? $avatarSize : '64px'}
                                $borderRadius={$avatarCircle ? '40px' : '16px'}
                            />
                        ) : (
                            <div
                                style={{
                                    width: $avatarSize ? $avatarSize : '64px',
                                    height: $avatarSize ? $avatarSize : '64px',
                                }}
                            >
                                <Skeleton
                                    component="div"
                                    variant="rect"
                                    width={$avatarSize ? $avatarSize : '64px'}
                                    height={$avatarSize ? $avatarSize : '64px'}
                                />
                            </div>
                        )}
                    </div>
                    <div style={{ width: '100%', marginLeft: '10px' }}>
                        {data ? (
                            <Title style={{ fontSize: '16px' }}>
                                {data?.meet?.staff?.user?.fullname}
                            </Title>
                        ) : (
                            <Skeleton width={150} height={30} variant="text" />
                        )}
                        {data ? (
                            <Text $color="purple" style={{ fontSize: '14px', marginTop: '10px' }}>
                                Online
                            </Text>
                        ) : (
                            <Skeleton width={100} height={30} variant="text" />
                        )}
                    </div>
                    <div
                        style={{
                            maxWidth: '400px',
                            gridColumnStart: $desktopLayout ? 2 : 1,
                            gridColumnEnd: 3,
                            alignSelf: 'end',
                        }}
                    >
                        {onClick && (
                            <ContainedButton
                                $height="32px"
                                disabled={!(today > session_startTime && today < session_endTime)}
                                onClick={onClick}
                                $backgroundColor={data?.actualStartTime ? 'green' : 'primaryBlue'}
                            >
                                {data?.actualStartTime ? 'Join' : 'Check in'}
                            </ContainedButton>
                        )}
                    </div>
                </div>
            </StyledCardContent>
        </StyledCard>
    );
};

AppointmentCard.propTypes = {
    data: PropTypes.object,
    $avatarSize: PropTypes.string,
    $desktopLayout: PropTypes.number,
    $avatarCircle: PropTypes.bool,
    onClick: PropTypes.any,
    $maxWidth: PropTypes.string,
};
